import { cart } from 'core/use-cases';

import type { TGenerateItemEvent, TItemEvent } from '../@types';
import type { Item } from 'core/domains/cart';

const ITEM_EVENT_TYPES = {
  REMOVE_FROM_CART: 'remove_from_cart',
  ADD_TO_CART: 'add_to_cart',
};

export const generateItemEvent = (props: TGenerateItemEvent): TItemEvent => {
  if (props.action.type === cart.actions.itemDeleteFetch.success.type) {
    const removedItemIndex = props.prevState.cart.data.items.findIndex(
      (item: Item) => item.productCode === props.productCode,
    );

    return {
      quantity: props.prevState.cart.data.items[removedItemIndex]?.previousQuantity || 0,
      type: ITEM_EVENT_TYPES.REMOVE_FROM_CART,
      itemAddedIndex: removedItemIndex,
    };
  }

  const itemAddedIndex =
    props.items.findIndex((item: Item) => item.productCode === props.productCode) || 0;

  if (props.action.type !== cart.actions.itemUpdateFetch.success.type) {
    return {
      quantity: 1,
      type: ITEM_EVENT_TYPES.ADD_TO_CART,
      itemAddedIndex,
    };
  }

  const previousQuantity = props.prevState.cart.data.items[itemAddedIndex]?.previousQuantity;
  const actualQuantity = props.action.meta.payload.quantity as number;

  if (props.action.meta.payload.quantity === 0) {
    return {
      quantity: 0,
      type: ITEM_EVENT_TYPES.REMOVE_FROM_CART,
      itemAddedIndex,
    };
  }

  if (previousQuantity > actualQuantity) {
    return {
      quantity: previousQuantity - actualQuantity,
      type: ITEM_EVENT_TYPES.REMOVE_FROM_CART,
      itemAddedIndex,
    };
  }

  if (previousQuantity < actualQuantity) {
    return {
      quantity: actualQuantity - previousQuantity,
      type: ITEM_EVENT_TYPES.ADD_TO_CART,
      itemAddedIndex,
    };
  }

  return { quantity: 1, type: ITEM_EVENT_TYPES.ADD_TO_CART, itemAddedIndex };
};
